<script>
import Layout from '@layouts/loggedin.vue'
import { authComputed } from '@state/helpers'
import Tab from '@router/components/tab.vue'
import Tabs from '@router/components/tabs.vue'
import Details from '@challenges/components/details.vue'

export default {
  components: {
    Layout,
    Tab,
    Tabs,
    Details,
  },
  data() {
    return {}
  },
  computed: {
    ...authComputed,
    isEditForm() {
      return false
    },
  },
  methods: {},
}
</script>

<template>
  <Layout>
    <div class="bg-white px-7.5 pt-4 text-xl">
      <span class="">Challenges</span>
      <span class="breadcrumb-separator">></span>
      <span class="text-blue">{{ isEditForm ? 'Edit' : 'New' }} Challenge</span>
    </div>

    <div>
      <Tabs
        ref="tabsWrap"
        :classes="'bg-white flex justify-around border-none'"
        :parent-classes="'bg-white flex justify-center'"
        :tab-classes="
          'border-b-5 pb-5 text-xl mr-16 leading-loose cursor-pointer'
        "
      >
        <Tab
          title='<span class="align-middle"><span class="text-2xl mr-1">&gt;&lt;</span> Head to Head</span>'
        >
          <div :class="$style.tabContent" class="py-12">
            <Details />
          </div>
        </Tab>
        <Tab
          title='<span class="flex"><svg class="mr-2" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 50 50" style="enable-background:new 0 0 50 50;" xml:space="preserve" width="30"><g id="Layer_1"><path fill="currentColor" d="M41,1H9v3H1v6c0,4.963,4.038,9,9,9h1.165c2.613,4.501,7.351,7.608,12.835,7.949V47h-9v2h20v-2h-9V26.949c5.484-0.342,10.222-3.448,12.835-7.949H40c4.962,0,9-4.037,9-9V4h-8V1z M10,17c-3.86,0-7-3.141-7-7V6h6v5c0,2.122,0.424,4.145,1.178,6H10z M25,25c-7.72,0-14-6.28-14-14V3h28v8C39,18.72,32.72,25,25,25z M47,6v4c0,3.859-3.14,7-7,7h-0.178C40.576,15.145,41,13.122,41,11V6H47z"/></g></svg> <span class="align-middle">Leaderboard</span></span>'
        >
          <div
            :class="$style.tabContent"
            class="pt-14 text-center text-xl pb-14"
          >
            Coming Soon!
          </div>
        </Tab>
      </Tabs>
    </div>
  </Layout>
</template>

<style lang="scss" module>
.tabContent {
  @apply bg-white mt-8 mx-7.5 px-8 rounded-xl shadow-lg;
}
</style>
